export const GET_SURVEYS_SUCCESS = "GET_SURVEYS_SUCCESS";
export const GET_SURVEYS_FAILURE = "GET_SURVEYS_FAILURE";

export const CREATE_SURVEY_SUCCESS = "CREATE_SURVEY_SUCCESS";
export const CREATE_SURVEY_FAILURE = "CREATE_SURVEY_FAILURE";

export const UPDATE_SURVEY_SUCCESS = "UPDATE_SURVEY_SUCCESS";
export const UPDATE_SURVEY_FAILURE = "UPDATE_SURVEY_FAILURE";

export const GET_SURVEY_RESPONSES_SUCCESS = "GET_SURVEY_RESPONSES_SUCCESS";
export const GET_SURVEY_RESPONSES_FAILURE = "GET_SURVEY_RESPONSES_FAILURE";

export const GET_SURVEY_ANALYTICS_SUCCESS = "GET_SURVEY_ANALYTICS_SUCCESS";
export const GET_SURVEY_ANALYTICS_FAILURE = "GET_SURVEY_ANALYTICS_FAILURE";
